function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.7241 12.4059C10.7241 13.4902 11.6039 14.3695 12.6877 14.3695C13.4492 14.3695 14.1018 13.9318 14.4275 13.2986L14.433 13.3035L18.0176 6.83643L11.7247 10.6953L11.7307 10.7012C11.1331 11.0384 10.7241 11.6712 10.7241 12.4059Z",
  fill: "#EFEFEF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.5985 3.04937C18.5863 1.29075 15.9865 0.167842 13.0159 0V2.98402C15.4914 3.14146 16.95 3.92769 18.4145 5.15457L20.5985 3.04937Z",
  fill: "#EFEFEF"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.0001 11.4756H24.9807C24.7807 8.50496 23.6187 6.06408 21.8145 4.06384L19.7058 6.15964C20.9763 7.61526 21.812 9.49518 22.0001 11.4756Z",
  fill: "#EFEFEF"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.014 12.9614C21.6986 17.9125 17.5966 21.8392 12.5861 21.8392C7.37018 21.8392 2.97065 17.609 2.97065 12.3935C2.97065 7.42859 7.0746 3.36623 11.5306 2.98499V0.000976562C5.09417 0.386666 0 5.80216 0 12.4064C0 19.2602 5.65414 24.8099 12.5079 24.8099C19.1582 24.8099 24.6826 19.3978 25 12.9614H22.014Z",
  fill: "#EFEFEF"
});

var SvgPerformanceIcon = function SvgPerformanceIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPerformanceIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/performance-icon.1060d7c1.svg";
export { ForwardRef as ReactComponent };